module.exports = __webpack_public_path__ + "static/media/shopify-connect_dark.2d3a0e27.png";